module.exports = __webpack_public_path__ + "img/play-button.fc115cdd.png";